<script setup>
import { computed, ref } from "vue";
import { useActivityStore } from "@/stores/useActivityStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

// ✅ agora também emite "notify", igual ao BatchDeleteTextForm
const emit = defineEmits(["close", "refresh", "notify"]);
const store = useActivityStore();

// ✅ IDs selecionados APENAS da página atual
const selectedIdsOnCurrentPage = computed(() => {
  const idsOnPage = store.activities.map((a) => a.activityId);
  return store.selectedActivityIds.filter((id) => idsOnPage.includes(id));
});

// ✅ quantidade selecionada NA PÁGINA
const selectedCount = computed(() => selectedIdsOnCurrentPage.value.length);

// ✅ congela ao abrir (pra não trocar o texto quando a store limpa seleção)
const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

// ✅ mensagem de confirmação com singular/plural
const messageTitle = computed(() => {
  if (frozenCount.value === 1)
    return "Tem certeza que deseja apagar a atividade selecionada?";
  return `Tem certeza que deseja apagar as ${frozenCount.value} atividades selecionadas?`;
});

function buildBatchDeleteActivityError(error) {
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir as atividades.";
  return raw;
}

async function onConfirmBatchDelete() {
  try {
    await store.deleteSelectedActivities();

    // ✅ Toast genérico, sem nome das atividades
    emit("notify", {
      type: "success",
      message:
        frozenCount.value === 1
          ? "Atividade apagada com sucesso."
          : "Atividades apagadas com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildBatchDeleteActivityError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    // deixa o DeleteConfirmModal saber que deu erro (para parar loading)
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Atividades em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-las serão excluídas também todas as Notas vinculadas a elas. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>
